<div *ngIf="loaded" class="tech-content containerMarginX">
  <div *ngIf="isback" class="containerMarginX flex-container-nowrap containerBack">
    <tech-back
      [direction]="'/portfolios'"
      *ngIf="isback"
      class="back">
    </tech-back>
  </div>
  <ul class="contenedor" *ngIf="!nodata; else nodata2">
    <li *ngFor="let item of services">
  <div class="card-whiteinvestmentservice data sinpadding bordetop cardDashboard">
    <div class="header borde">
      <img class="imgCard" src="{{ getimagen(item.Image) }}" />
    </div>
    <div class="body">
      <span class="titulo1">{{ 'k003284' | translate }} </span><!-- Nuevo servicio de inversión-->
      <span class="titulo2">{{ item.ServiceModelName }}</span><!--Carteras agrupadas administradas-->
      <p class="titulo3">{{ item.ServiceModelDescription?item.ServiceModelDescription: "Lorem ipsum dolor sit amen invertis invertis ademdum portfolios monetarius in inversus conservus"  }}</p><!--Lorem ipsum dolor sit amen invertis invertis ademdum portfolios monetarius in inversus conservus-->
    </div>
    <div class="footer">
      <button
        type="mat-flat-button"
        class="buttonPortal lg"
        (click)="item.IsAccessible? goModal(item) : clickgoto(item.ServiceModelCode)"
      >
      <span>{{ 'k004297' | translate }}</span>&nbsp;
      <fa-icon
        *ngIf="item.IsAccessible"
        class="infoDanger warning"
        [icon]="['fas', 'exclamation-circle']"
        (click)="goModal(item)"
      ></fa-icon><!--warning infowarning-->
      </button>
    </div>
  </div>
</li>
</ul>
<!--
  <ul class="contenedor" *ngIf="!nodata; else nodata2">
    <li *ngFor="let item of services">
      <div class="card-whiteinvestmentservice data sinpadding bordetop cardDashboard">
        <div class="header borde">
          <div class="logoname">
            <fa-icon class="imgs" [icon]="['fal', 'chart-mixed']"></fa-icon>
          </div>
          <div class="name">
            <span>{{ item.ServiceModelName }}</span>
          </div>
        </div>
        <div class="body">
          <img class="imgCard" src="{{ getimagen(item.Image) }}" />
        </div>
        <div class="footer">
          <p>{{ item.ServiceModelDescription }}</p>
          <button
            type="button"
            class="buttonPortal mb-3"
            (click)="clickgoto(item.ServiceModelCode)"
            [disabled]="!item.IsAccessible"
            mat-raised-button
          >
            <span>{{ 'k000018' | translate }}</span>&nbsp;
            <fa-icon
              *ngIf="!item.IsAccessible"
              class="infoDanger red"
              [icon]="['fas', 'exclamation-circle']"
              (click)="goModal(item)"
            ></fa-icon>
          </button>
        </div>
      </div>
    </li>
  </ul>
-->
</div>
<ng-template #nodata2>
  <div *ngIf="nodata" class="nodata">
    <!---
    <div class="icono">
      <fa-icon [icon]="['fal', 'home']" class="imgnodata"></fa-icon>
    </div>-->
    <div class="texto">
      <span>{{ 'k002559' | translate }}</span>
    </div>
  </div>
</ng-template>



<!--
<div *ngIf="loaded" class="containerMarginX">
  <ul class="contenedor" *ngIf="!nodata; else nodata2">
    <li *ngFor="let item of services">
      <div
        class="card-whiteinvestmentservice data sinpadding bordetop cardDashboard"
      >
        <div class="header borde">
          <div class="logoname">
            <fa-icon class="imgs" [icon]="['fal', 'chart-mixed']"></fa-icon>
          </div>
          <div class="name">
            <span>{{ item.ServiceModelName }}</span>
          </div>
        </div>
        <div class="body">
          <img class="imgCard" src="{{ getimagen(item.Image) }}" />
        </div>
        <div class="footer">
          <p>{{ item.ServiceModelDescription }}</p>
          <button
            type="button"
            class="buttonPortal mb-3"
            (click)="clickgoto(item.ServiceModelCode)"
            [disabled]="!item.IsAccessible"
            mat-raised-button
          >
            <span>{{ 'k000018' | translate }}</span>&nbsp;
            <fa-icon
              *ngIf="!item.IsAccessible"
              class="infoDanger red"
              [icon]="['fas', 'exclamation-circle']"
              (click)="goModal(item)"
            ></fa-icon>
          </button>
        </div>
      </div>
    </li>
  </ul>
  <div class="sectionContainer">
    <div class="buttonContainerFlex flex-space-between">
      <button
        type="button"
        class="buttonPortal lg cancel"
        mat-raised-button
        (click)="goBack()"
      >
        <span>{{ 'k000214' | translate }}</span>
      </button>
    </div>
  </div>
</div>

<ng-template #nodata2>
  <div *ngIf="nodata" class="nodata">
    <div class="icono">
      <fa-icon [icon]="['fal', 'home']" class="imgnodata"></fa-icon>
    </div>
    <div class="texto">
      <span>{{ 'k003240' | translate }}</span>
    </div>
  </div>
</ng-template>
-->
